import {
  Column,
  Copy,
  Heading,
  Row,
  Square,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { TimeIntervalSegmentedControl } from 'src/components/oneCorp/features/MealCredit/common/formFields/SegmentedControl/TimeIntervalSegmentedControl';
import { DayTags } from 'src/components/oneCorp/features/MealCredit/common/formFields/Tag/DayTags/DayTags';
import { MonthAvailabilityWrapper } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/CreditAvailabilityLayout/MonthlyAvailabilityWrapper/MonthAvailabilityWrapper';
import { TimeSelection } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/CreditAvailabilityLayout/TimeSelection/TimeSelection';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';

export function CreditAvailabilityLayout(): JSX.Element {
  const {
    isEditing,
    formValues: { isMonthAvailable, isDaysAvailable },
  } = useMealCreditFormData();

  return (
    <Square inset="md" bg="stencilHighlight">
      <Stack y="sm">
        <Heading variant="h6">
          When can recipients receive orders with this credit?
        </Heading>
        <Copy variant="caption">
          Preorders can be made in advance but must be delivered within the
          ordering window.
        </Copy>
      </Stack>
      {isMonthAvailable && (
        <Stack y="sm">
          <MonthAvailabilityWrapper />
        </Stack>
      )}
      <Stack y="sm">
        <Row>
          <Column phone={12}>
            <DayTags name="days" id="days" disabled={!isDaysAvailable} />
          </Column>
        </Row>
      </Stack>
      <Row gutter={12}>
        <Column phone={4} gutter={12}>
          <TimeIntervalSegmentedControl
            id="timeIntervalType"
            name="timeIntervalType"
            disabled={isEditing}
          />
        </Column>
        <Column phone={8} desktop={7} gutter={12}>
          <TimeSelection />
        </Column>
      </Row>
    </Square>
  );
}
